import React, { FC, useMemo } from 'react'
import {
  Filters as FiltersVisualisation,
  FiltersProps,
  FilterInputProps,
  ThematicsSelect,
  PeriodDatePicker
} from '@src/containers/Visualisation/components'

import * as Styled from './Filters.styled'

const FiltersInputs: FC<FilterInputProps> = ({
  data,
  formValues,
  availableDateRange,
  isFetching,
  handleSelectChange,
  handleDateChange,
  handleOpenThemeClassifierModal
}) => {
  const options = useMemo(() => {
    return data?.theme?.map(({ id, name }) => ({ value: id.toString(), label: name })) ?? []
  }, [data])

  const valuePeriodDatePicker = useMemo(() => {
    return {
      min: formValues.min ? new Date(Number(formValues.min)) : undefined,
      max: formValues.max ? new Date(Number(formValues.max)) : undefined
    }
  }, [formValues])

  return (
    <>
      <ThematicsSelect
        options={options}
        value={formValues.theme}
        isDisabled={isFetching}
        label="theme"
        onChange={handleSelectChange}
        onTooltipLinkClick={handleOpenThemeClassifierModal}
        isAnalytics
      />
      <PeriodDatePicker
        availableDateRange={availableDateRange}
        value={valuePeriodDatePicker}
        disabled={isFetching}
        onChange={handleDateChange}
        isAnalytics
      />
    </>
  )
}

const Filters: FC<FiltersProps> = ({ data, isFetching, fetchData }) => {
  const methodologyModalData = useMemo(() => {
    return {
      period: <>Собираем данные с&nbsp;июля 2024&nbsp;года, обновляем ежемесячно</>,
      placement: <>Более 30&nbsp;000 рекламных публикаций</>,
      analytics: (
        <>
          Анализируем размещения рекламодателей в&nbsp;Telegram-каналах через платформу{' '}
          <Styled.Link href="https://telega.in/" target="_blank" rel="noopener noreferrer">
            Telega.in
          </Styled.Link>
        </>
      ),
      description: (
        <>
          Все метрики внутри тематических категорий рассчитываем по&nbsp;медианным
          значениям,&nbsp;&mdash; стоимость интеграций в&nbsp;отдельных блогах и&nbsp;биржах могут
          от&nbsp;них отличаться
        </>
      )
    }
  }, [])

  return (
    <Styled.Container
      as={FiltersVisualisation}
      data={data}
      isFetching={isFetching}
      fetchData={fetchData}
      methodologyModalData={methodologyModalData}
      FilterInputs={FiltersInputs}
    />
  )
}

export default Filters
